
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/mini-degens",
      function () {
        return require("private-next-pages/projects/mini-degens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/mini-degens"])
      });
    }
  